import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { cmsApi } from '../apis/cmsApi/cms.api';
import { mlkApi } from '../apis/mlkApi/mlk.api';
import { appStart } from './general/general.actions';
import { generalReducer } from './general/general.slice';
import { mainMiddleware } from './middlewares/general.middleware';
import { userReducer } from './user/user.slice';

export const store = configureStore({
  reducer: {
    general: generalReducer,
    user: userReducer,
    [cmsApi.reducerPath]: cmsApi.reducer,
    [mlkApi.reducerPath]: mlkApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(mainMiddleware)
      .concat(mlkApi.middleware)
      .concat(cmsApi.middleware),
});

setupListeners(store.dispatch);

store.dispatch(appStart);
